import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../msalConfig';
import { 
  Box, 
  AppBar, 
  Toolbar, 
  Typography, 
  Container, 
  Button,
  Paper,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

function AdminLogin() {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = React.useState(false);

    useEffect(() => {
        if (accounts.length > 0) {
            navigate('/admin-dashboard');
        }
    }, [accounts, navigate]);

    const handleLogin = async () => {
        setIsLoading(true);
        try {
            await instance.loginPopup(loginRequest);
            // The useEffect hook will handle the navigation after successful login
        } catch (e) {
            console.error('Login failed:', e);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box 
          sx={{ 
            minHeight: '100vh',
            bgcolor: 'background.default',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
            <AppBar position="fixed" className="mainAppBar">
                <Toolbar>
                    <img src="/aqiliSmartObject.png" alt="Logo" style={{ height: 40, marginRight: 16 }} />
                    <Typography variant="h4" sx={{ flexGrow: 1 }}>
                        aqili
                    </Typography>
                </Toolbar>
            </AppBar>

            <Container 
                component="main" 
                maxWidth="sm" 
                sx={{ 
                    mt: 12,
                    mb: 4,
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                <Paper 
                    elevation={3} 
                    sx={{ 
                        p: 4,
                        width: '100%',
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        marginTop: '100px'
                        
                    }}
                >
                    <Typography 
                        component="h1" 
                        variant="h4" 
                        align="center" 
                        gutterBottom
                        sx={{ 
                            fontWeight: 600,
                            color: 'primary.main'
                        }}
                    >
                        Portal Login
                    </Typography>

                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={handleLogin}
                        disabled={isLoading}
                        sx={{ 
                            py: 1.5,
                            fontSize: '1.1rem',
                            position: 'relative'
                        }}
                    >
                        {isLoading ? (
                            <>
                                <CircularProgress 
                                    size={24} 
                                    sx={{ 
                                        position: 'absolute',
                                        left: '50%',
                                        marginLeft: '-12px'
                                    }}
                                />
                                <span style={{ visibility: 'hidden' }}>
                                    Administrator Login
                                </span>
                            </>
                        ) : (
                            'Administrator Login'
                        )}
                    </Button>

                    <Button
                        fullWidth
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate('/')}
                        sx={{ 
                            py: 1.5,
                            fontSize: '1.1rem'
                        }}
                    >
                        Return to Interview Login
                    </Button>
                </Paper>
            </Container>
            
            <Footer />
        </Box>
    );
}

export default AdminLogin;